export class SockPkt {
  public cpgn: string;
  public user: string;
  public text: string;
}

